/**
 * BOTTOM GENERAL INITS
 * BREAKDOWN
 */

import { Breakdown } from "./breakdown";


export class BreakdownInits {
    constructor() {
        this.initMap();
    };

    initMap() {
        const headlines = $('.card__heading').filter((index, item) => {
            return !$(item).parents('.card-news--aperture, .card-gallery--aperture').length;
        });

        if (headlines.length) {
            const headlinesWithAnchor = headlines.has('a.lnk');

            new Breakdown(headlinesWithAnchor.children('a.lnk'));
            new Breakdown(headlines.filter(headlinesWithAnchor));
        }
    };
}
